import React from "react";
import { Container, Typography } from "@material-ui/core";
import withAuth from "../auth/withAuth";
import AuthHelperMethods from "../../util/AuthHelperMethods";
import ExportPopover from "../ExportPopover";

const Auth: any = new AuthHelperMethods();

const HomeAdmin = function HomeAdmin() {
  return (
    <Container component="main" maxWidth="xs">
      <img
        src="hageland.jpg"
        style={{ width: "100%", marginBottom: "15px" }}
        alt="Logo 112 Hageland"
      ></img>
      <div style={{ textAlign: "center", marginBottom: "15px" }}>
        <Typography component="h1" variant="h4">
          Welkom,{" "}
          {Auth.getConfirm().firstName
            ? Auth.getConfirm().firstName
            : Auth.getConfirm().userName}
          !
        </Typography>
      </div>
      <div style={{ padding: "15px" }}>
        <ExportPopover />
      </div>
    </Container>
  );
};

export default withAuth(HomeAdmin);
